import axios from 'axios'
import * as Util from '@/vuex/util'

let startState = {}

const state = {
  rankings: startState
}

const mutations = {
  FETCH (state, params) {
    axios.get(Util.makeApiFilterUrl(params.slug, params.filters)).then(function (response) {
      state.rankings = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.rankings = startState
  }
}

const actions = {
  fetch: function ({commit}, params) {
    commit('FETCH', params)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.rankings
}

export const WhoRank = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tables/WhoRank.js